<section class="pl-[242px] block" id="about" data-scroll-section>
  <div class="what_weDo relative max-w-full" data-scroll data-scroll-speed="3">
    <div class="sec_head">
      <span class="for_mob">About Me</span>
      <h2>Building Bridges Through Innovation</h2>
    </div>
    <p>
      I am a passionate Full Stack Developer (Angular + Node) dedicated to transforming ideas into impactful digital
      solutions. By bridging the gap between technology and business goals, I deliver products and
      experiences that engage users and drive success.
    </p>
    <p class="mt-[15px]">
      Whether collaborating with companies to enhance their digital presence or partnering with
      clients to bring visionary projects to life, my focus is on creating meaningful, lasting
      connections through code.
    </p>
    <div class="what_weDo_btn leading-4">
      <a routerLink="/about" class="common-arrow">
        Know more
        <span><i class="fa-solid fa-arrow-right"></i></span>
      </a>
    </div>
  </div>
</section>
